import React from 'react'

const ResponseMessage = ( props ) => {

  const type = props.response.type ?? ''
  const message = props.response.message ?? ''

  return (
    <div className={`msync-message-response msync-message-response-${ type }`}>
        <div className='msync-message-response-text'>
            <span>{ message }</span>
        </div>
    </div>
  )
}

export default ResponseMessage